<!-- <polyline points="5,5 45,25 5,45" pointer-events="none"/> -->
<!-- <g pointer-events="none" transform="scale(0.7)" transform-origin="25 25"> -->

<!-- 
   translate(10 10) ist geschätzt und sieht optisch brauchbar aus.
   transform-origin="25 25" wäre besser, wird aber von Word und Inkscape nicht unterstützt
-->

<g pointer-events="none" transform="scale(0.7) translate(10 10)">
<ellipse
       style="fill:#ff0000;stroke:#000000;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000"
       id="path234"
       cx="24.831696"
       cy="25.230284"
       rx="15.096681"
       ry="14.230256" />
    <path
       style="fill:#000000;fill-opacity:1;stroke:#000000;stroke-width:1.96341;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000"
       d="m 34.238461,29.45734 -1.310227,-4.369671 1.278064,-4.261501 1.278066,-4.2615 0.205938,0.238786 c 1.759061,2.039625 2.823745,4.396653 3.140984,6.953612 0.083,0.668869 0.08293,2.279165 -8.9e-5,2.947409 -0.314568,2.531709 -1.356763,4.850453 -3.109726,6.918682 l -0.172782,0.203857 z"
       id="path582" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000"
       d="m 39.928372,21.06448 c 0,0 4.173544,0.459392 6.038676,-1.006445 1.420444,-1.116349 2.01289,-5.032227 2.01289,-5.032227"
       id="path1927" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000"
       d="m 39.928372,29.116042 c 0,0 4.173544,-0.459392 6.038676,1.006445 1.420444,1.116349 2.01289,5.032227 2.01289,5.032227"
       id="path1927-6" />
    <circle
       style="fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000"
       id="path2740"
       cx="37.915485"
       cy="23.077372"
       r="1.0064453" />
    <circle
       style="fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path2740-20"
       cx="19.799469"
       cy="20.058035"
       r="1.0064453" />
    <circle
       style="fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path2740-20-2"
       cx="19.799469"
       cy="30.122488"
       r="1.0064453" />
    <circle
       style="fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path2740-20-1"
       cx="27.85103"
       cy="18.045143"
       r="1.0064453" />
    <circle
       style="fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stroke-opacity:1;stop-color:#000000"
       id="path2740-20-17"
       cx="27.85103"
       cy="32.135376"
       r="1.0064453" />
    <circle
       style="fill:#ffffff;fill-opacity:1;stroke:none;stroke-width:1.96342;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000"
       id="path2740-2"
       cx="37.915485"
       cy="27.103153"
       r="1.0064453" />
    <path
       style="fill:#ffffff;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="M 9.7350152,25.09026 H 31.876812"
       id="path5027" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="m 29.863921,11.000026 c 0,0 0.424355,-2.7527173 0,-4.0257809 C 29.333478,5.3829154 26.844586,2.9484638 26.844586,2.9484638"
       id="path6579" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="m 20.806417,11.00053 c 0,0 -1.224126,-2.7495335 -2.01289,-4.0257818 C 17.911661,5.5478593 15.77419,2.948967 15.77419,2.948967"
       id="path6579-3" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="m 12.754351,16.032253 c 0,0 -2.338344,-3.157396 -4.0257811,-4.025781 C 6.9140847,11.072705 2.6898982,11.000026 2.6898982,11.000026"
       id="path6579-3-2" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="m 12.754351,34.148268 c 0,0 -2.338344,3.157395 -4.0257811,4.02578 -1.8144852,0.93377 -6.0386715,1.006449 -6.0386715,1.006449"
       id="path6579-3-2-0" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="m 21.812359,39.180497 c 0,0 -1.224126,2.749527 -2.012891,4.025777 -0.881866,1.426889 -3.019335,4.025781 -3.019335,4.025781"
       id="path6579-3-5" />
    <path
       style="fill:none;fill-opacity:1;stroke:#000000;stroke-width:1.96244;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;stop-color:#000000"
       d="m 29.863921,39.180497 c 0,0 0.424355,2.752714 0,4.025777 -0.530443,1.59133 -3.019335,4.025785 -3.019335,4.025785"
       id="path6579-0" />

</g>